const WorktypeSelectOptions = {
    ALL_WORKTYPES: {
        value: -1,
        label: 'Alle Worktypes',
    },
};

module.exports = { WorktypeSelectOptions };
